export default __webpack_public_path__ + "static/media/privacyPolicy_root_background.244c65d8.jpg";